export default __webpack_public_path__ + "static/media/qr-desktop.9070d184.svg";